import Usuario from "model/administracao/cadastro/Usuario";
import { BaseEditModel } from "model/BaseEditModel";
import Veiculo from "./Veiculo";

export default class UsuarioVeiculo implements BaseEditModel {
    id: number;
    sequencial: number | null = 0;
    key: string | null = "";
    usuario: Usuario | null;
    veiculo: Veiculo | null;
    veiculoPadraoDoUsuario: boolean;

    constructor(
        id = 0,
        usuario = null,
        veiculo = null,
        veiculoPadraoDoUsuario = false
    ) {
        this.id = id;
        this.usuario = usuario;
        this.veiculo = veiculo;
        this.veiculoPadraoDoUsuario = veiculoPadraoDoUsuario;
    }
}